export const EMERGING_THREATS_CLIENTS_QUERY = '/emerging-threats/list-for-clients';
export const EMERGING_THREAT_LIST_WITH_SUPPLIER_RESPONSE_QUERY =
  '/emerging-threats/supplier/:supplierID/threat-list';
export const EMERGING_THREATS_SUPPLIER_QUESTION_ANSWERS_QUERY =
  '/emerging-threats/supplier/question-answers';
export const EMERGING_THREAT_CLIENT_METRICS_QUERY = '/emerging-threats/:id/metrics';
export const EMERGING_THREAT_SUPPLIERS_QUERY = '/emerging-threats/:id/suppliers';
export const EMERGING_THREAT_SUPPLIER_QUESTION_ANSWERS_QUERY =
  '/emerging-threats/:id/supplier/:id/answers';
export const EMERGING_THREAT_SUPPLIER_POTENTIAL_THREAT_COUNT_QUERY =
  '/emerging-threats/:id/supplier/:id/threat-list';
